import { DIVIDER_COLOR } from "../../../foundations/palette.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
const SMALL_DIALOG_MAX_WIDTH = 328;
const dialogStyleOverrides = {
  root: {
    ".MuiPaper-root": {
      padding: Spacing["1500"],
      border: `1px solid ${DIVIDER_COLOR}`
    },
    ".align-end": {
      width: "100%"
    },
    ".inner-icon > .MuiSvgIcon-root": {
      width: Spacing["3000"],
      height: Spacing["3000"]
    }
  },
  paperWidthXs: {
    maxWidth: SMALL_DIALOG_MAX_WIDTH
  }
};
export {
  dialogStyleOverrides
};
//# sourceMappingURL=dialog.es.js.map
